export const getLatestNote = (connection) => {
    // Notes come from back-end with most recent first.
    const latestNote = connection.notes[0];
    // returns llm_note -> raw_note -> empty state (null while a note is still being
    // generated from a recent conversation, so the card can show its pending message)
    return latestNote?.llm_note?.summary ?? latestNote?.raw_note ?? (connection?.notes_pending ? null : "No notes available");
};

export const getNotesSection = (connection) => {
    return connection?.connection?.summary ?? getLatestNote(connection);
};
